<mc-loading [overlay]="true" *ngIf="loading"></mc-loading>
<div class="modal-container">
    <div class="row justify-content-between px-3 design-modal-title-container">
        <p class="design-modal-title">{{ 'app.global.modals.image_manager.upload_image_modal.title' | translate }}</p>
        <i class="fa-solid fa-xmark closing-button" (click)="closeDialog()"></i>
    </div>
    <div class="d-flex flex-column flex-md-row align-items-start pt-4">
        <div class="col-12 col-md-4 px-2 mb-3 mb-xl-0">
            <!-- MENU -->
            <ng-container *ngFor="let card of cards; let i = index">
                <mat-card
                    *ngIf="card.show"
                    class="menu-card"
                    [ngClass]="{ 'selected-card': selectedCardId === card.id }"
                    (click)="selectCard(card.id)"
                >
                    <div class="d-flex align-items-center justify-content-start px-2">
                        <i *ngIf="card.icon?.length" class="{{ card.icon }}"></i>
                        <img
                            *ngIf="card.url?.length"
                            class="mr-2"
                            width="35"
                            height="35"
                            src="{{ assetsUrl }}{{ mfsPath }}{{ card.url }}"
                            [alt]="'PEXELS LOGO'"
                        />
                        <mat-card-title class="menu-option">{{ card.title }}</mat-card-title>
                    </div>
                </mat-card>
            </ng-container>
            <div
                class="notification-alert rounded mt-3 mb-3"
                [ngStyle]="!(isMobile$ | async) ? { position: 'absolute', top: '55vh' } : {}"
            >
                <i class="fal fa-info-circle mr-2"></i>
                <p class="mb-0">
                    {{ 'app.global.modals.image_manager.upload_image_modal.notification_msg' | translate }}
                </p>
            </div>
        </div>
        <div class="col-12 col-md-8 px-2 pl-md-5">
            <!-- COMPONENT CONTAINER -->
            <div class="container-box d-flex flex-wrap justify-content-center justify-content-lg-start">
                <ng-container [ngSwitch]="selectedCardId">
                    <ng-container *ngSwitchCase="1">
                        <file-upload
                            [data]="params"
                            (closeDialog)="closeDialog()"
                            class="w-100 position-relative"
                        ></file-upload>
                    </ng-container>
                    <ng-container *ngSwitchCase="2">
                        <url-upload [data]="params" (closeDialog)="closeDialog()" class="w-100"></url-upload>
                    </ng-container>
                    <ng-container *ngSwitchCase="3">
                        <instagram-upload
                            [data]="params"
                            class="w-100"
                            (closeDialog)="closeDialog()"
                        ></instagram-upload>
                    </ng-container>
                    <ng-container *ngSwitchCase="4">
                        <pexels-upload [data]="params" class="w-100" (closeDialog)="closeDialog()"></pexels-upload>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</div>
